import { Alert, Button, Modal } from '@hakimo-ui/shared/ui-base';

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
  /** Why the delete was refused. Shown here: the side panel is behind us. */
  error?: string | null;
  /** What is being deleted, e.g. "line" */
  noun?: string;
}

export function DeleteZoneModal({
  open,
  onClose,
  onConfirm,
  isDeleting,
  error,
  noun = 'zone',
}: Props) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Confirm Delete"
      footer={
        <>
          <Button
            variant="error"
            onClick={onConfirm}
            loading={isDeleting}
            disabled={isDeleting}
            autoFocus
          >
            Delete
          </Button>
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
        </>
      }
      closable={!isDeleting}
    >
      <div className="space-y-3 p-6">
        <p className="text-onlight-text-1 dark:text-ondark-text-1">
          Are you sure you want to delete this {noun}? This action cannot be
          undone.
        </p>
        {error && (
          <Alert type="error" size="small">
            {error}
          </Alert>
        )}
      </div>
    </Modal>
  );
}
